import React from "react";
import {
  AboutContent,
  AboutDetailsContainer,
  AboutHighlights,
  AboutImage,
  AboutImageContainer,
  AboutIntro,
  HighlightCard,
  HighlightDescription,
  HighlightTitle,
  Resume,
  ResumeLink,
  SectionHeading,
  SectionTitle,
  StatCard,
  StatGrid,
  StatLabel,
  StatValue,
  StyledAbout,
  ToolBadgeRow,
  ToolChip,
} from "../../Styled/About/About.style";
import { StyledParagraph } from "../../Styled/Typograpystyle/Typography.style";

const highlightData = [
  {
    title: "Product-minded execution",
    description: "Translate business goals into UX flows, design systems, and launch roadmaps.",
  },
  {
    title: "Full-stack delivery",
    description: "Own MERN builds end-to-end with CI/CD, observability, and documentation.",
  },
  {
    title: "Growth partnerships",
    description: "Embed with cross-functional teams to iterate on performance and conversion.",
  },
];

const stats = [
  { value: "03+", label: "Years crafting web products" },
  { value: "25+", label: "Production releases shipped" },
  { value: "3x", label: "Average lighthouse uplift" },
];

const tooling = ["Next.js", "MERN", "WordPress", "Shopify", "Framer Motion", "Tailwind"];

const portrait =
  "https://res.cloudinary.com/deyk2vhta/image/upload/v1763635018/Gemini_Generated_Image_wa8zdcwa8zdcwa8z_mnh0ur.png";

const About = () => {
  return (
    <StyledAbout id="about">
      <SectionHeading dark="true" mb="3rem">
        <SectionTitle dark="true" number="02">
          About Me
        </SectionTitle>
      </SectionHeading>
      <AboutContent>
        <AboutImageContainer>
          <AboutImage src={portrait} alt="Portrait of Enam Hossain" loading="lazy" />
        </AboutImageContainer>
        <AboutDetailsContainer>
          <AboutIntro>
            <StyledParagraph>
              I&apos;m Mohammad Enam Hossain—your go-to full-stack website developer focused on
              performance-first MERN applications, WordPress ecosystems, and Shopify storefronts.
              Based in Bangladesh, I embed with founders and product teams to turn complex ideas into
              systems that scale.
            </StyledParagraph>
            <StyledParagraph>
              My process blends product thinking, collaborative workshops, and automation-driven
              delivery. From prototyping in Figma to deploying CI-ready code, I create responsive,
              accessible experiences with measurable impact.
            </StyledParagraph>
          </AboutIntro>

          <AboutHighlights>
            {highlightData.map((item) => (
              <HighlightCard key={item.title}>
                <HighlightTitle>{item.title}</HighlightTitle>
                <HighlightDescription>{item.description}</HighlightDescription>
              </HighlightCard>
            ))}
          </AboutHighlights>

          <StatGrid>
            {stats.map((stat) => (
              <StatCard key={stat.label}>
                <StatValue>{stat.value}</StatValue>
                <StatLabel>{stat.label}</StatLabel>
              </StatCard>
            ))}
          </StatGrid>

          <ToolBadgeRow>
            {tooling.map((tool) => (
              <ToolChip key={tool}>{tool}</ToolChip>
            ))}
          </ToolBadgeRow>

          <Resume>
            <ResumeLink
              href="https://drive.google.com/file/d/11g5TeVJfQnM91C_akNT-dbrr4En4fFEy/view?usp=drive_link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Download Resume
            </ResumeLink>
          </Resume>
        </AboutDetailsContainer>
      </AboutContent>
    </StyledAbout>
  );
};

export default About;